<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> TIPO PRODUTO </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="productType.id"
          >{{ productType.id }} -
          {{ productType.name.toUpperCase() }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="4">
              <v-text-field
                v-model="productType.name"
                class="text-field-uppercase"
                label="Nome"
                dense
                outlined
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <label class="text-h6">Campos Ficha Técnica</label>
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card elevation="2">
                <v-card-title>Campos Disponíveis</v-card-title>
                <v-card-text>
                  <v-simple-table dense height="350px" fixed-header>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Campo</th>
                          <th class="text-left">Tipo</th>
                          <th class="text-left">Valor</th>
                          <th class="text-left">Ação</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="item in orderByName(filterSelected(fields))"
                          :key="item.id"
                        >
                          <td>{{ item.name }}</td>
                          <td>{{ translateType(item) }}</td>
                          <td
                            v-if="item.values.length > 0"
                            class="font-weight-bold"
                          >
                            {{
                              item.values.map((item) => item.text).join(" | ")
                            }}
                          </td>
                          <td v-else></td>
                          <td>
                            <v-btn
                              color="blue darken-3"
                              small
                              dark
                              class="mt-1 mb-1 float-right"
                              @click="selectField(item)"
                            >
                              <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>
                <v-card-text class="font-weight-bold"
                  >{{ filterSelected(fields).length }} Campos</v-card-text
                >
              </v-card>
            </v-col>
            <v-col>
              <v-card elevation="2">
                <v-card-title>Campos Selecionados</v-card-title>
                <v-card-text>
                  <v-simple-table dense height="350px" fixed-header>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Campo</th>
                          <th class="text-left">Tipo</th>
                          <th class="text-left">Valor</th>
                          <th class="text-left">Ação</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in fieldsSelected" :key="item.id">
                          <td>{{ item.name }}</td>
                          <td>{{ translateType(item) }}</td>
                          <td
                            v-if="item.values.length > 0"
                            class="font-weight-bold"
                          >
                            {{
                              item.values.map((item) => item.text).join(" | ")
                            }}
                          </td>
                          <td v-else></td>
                          <td class="">
                            <v-btn
                              color="red darken-3"
                              small
                              dark
                              class="mt-1 mb-1 float-right"
                              @click="removeFieldSelected(item)"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>
                <v-card-text class="font-weight-bold"
                  >{{ fieldsSelected.length }} Campos</v-card-text
                >
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="blue darken-3" dark class="mt-5" @click="validate">
                <v-icon left>mdi-send</v-icon> Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import * as API from "@/api/requests/ProductTypeRequest";

export default {
  components: {},
  data: () => ({
    loading: false,
    productType: {
      id: "",
      name: "",
    },
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
    fields: [],
    fieldsSelected: [],
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.getFields();
      if (this.$route.params.id) {
        this.getProductType(this.$route.params.id);
      }
    },
    async getProductType(id) {
      this.loading = true;
      try {
        this.productType = await API.getById(id);
        console.log(this.productType);
        this.fieldsSelected = this.productType.fields;
        console.log(this.fieldsSelected);
      } catch (error) {
        this.productType = {};
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getFields() {
      this.loading = true;
      try {
        this.fields = await API.getAll("/fields");
        // .map((item) => ({
        //   ...item,
        //   values: JSON.parse(item.values),
        // }));
      } catch (error) {
        this.fields = {};
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    goToBackList() {
      this.$router.push({ name: "ProductType" });
    },
    validate() {
      // if (this.$refs.form.validate()) {
      let data = {};
      data.name = this.productType.name.toUpperCase();
      data.fields = this.fieldsSelected.map((item) => item.id);
      if (this.productType.id === "") {
        this.post(data);
      } else {
        this.update(this.productType.id, data);
      }
      // }
    },
    async post(data) {
      // this.showLoading();
      this.loading = true;
      try {
        await API.post(data);
        this.goToBackList();
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    async update(id, data) {
      this.loading = true;
      try {
        API.update(data);
        this.goToBackList();
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    getLabelStatus(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },
    selectField(item) {
      this.fieldsSelected.push(item);
      this.fieldsSelected = this.orderByName(this.fieldsSelected);
    },
    removeFieldSelected(item) {
      let index = this.fieldsSelected.findIndex(
        (value) => value.id === item.id
      );
      console.log(index);
      this.fieldsSelected.splice(index, 1);
      this.fieldsSelected = this.orderByName(this.fieldsSelected);
    },
    filterSelected(fields) {
      return fields.filter(
        (item) =>
          this.fieldsSelected.find(
            (fieldSelected) => fieldSelected.id === item.id
          ) === undefined
      );
    },
    orderByName(data) {
      return data.sort((a, b) => (a.name > b.name ? 1 : -1));
    },
    translateType(item) {
      switch (item.type) {
        case "selection":
          return "Campo de Seleção";
        case "table":
          return item.values.label;
        default:
          return "Campo de Texto";
      }
    },
    // orderedItems(items) {
    //   return items.sort((a, b) => {
    //     if (a.name.toUpperCase() < b.name.toUpperCase()) {
    //       return -1;
    //     }
    //     if (a.name.toUpperCase() > b.name.toUpperCase()) {
    //       return 1;
    //     }
    //     // names must be equal
    //     return 0;
    //   });
    // },
  },
};
</script>
<style>
.text-field-uppercase input {
  text-transform: uppercase;
}
</style>
